

























































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {validationMixin} from 'vuelidate';
import {email, required} from 'vuelidate/lib/validators';
import router from '../../router';
import {MedTransGoConstants} from '../../util/constants';
import {Address, MemberProfileRequest} from '../../types/request';
import {ObjectFactory} from '../../config/objectFactory';
import {MapUtils} from '../../util/mapUtils';
import {CommonUtils} from '../../util/commonUtils';
import {ToastEvent} from '../../types/event';
import {EventBus} from '../../main';
import MessageBox from '../../components/MessageBox.vue';

declare var google: any;

@Component({
    mixins: [validationMixin],
    props: {
        memberRequest: Object,
    },
    data() {
        return {
            accessCode: '',
            locationId: '',
            showInvalidOrgAddressError: false,
            showInvalidLocAddressError: false,
            expectedOrgAddress: '',
            expectedLocAddress: '',
        };
    },
    methods: {
        checkOrgAddress() {
            if (this.$props.memberRequest.organizationAddress.latitude &&
                this.$props.memberRequest.organizationAddress.fullAddress.
                localeCompare(this.$data.expectedOrgAddress.fullAddress)) {
                this.$data.showInvalidOrgAddressError = false;
            } else {
                this.$data.showInvalidOrgAddressError = true;
            }
        },
        checkLocAddress() {
            if (this.$props.memberRequest.locationAddress.latitude &&
                this.$props.memberRequest.locationAddress.fullAddress
                .localeCompare(this.$data.expectedLocAddress.fullAddress)) {
                this.$data.showInvalidLocAddressError = false;
            } else {
                this.$data.showInvalidLocAddressError = true;
            }
        },
    },
    components: {
        MessageBox,
    },
    watch: {
        expectedOrgAddress() {
            const selectedAddress = this.$props.memberRequest.organizationAddress;
            if (selectedAddress.latitude) {
                this.$data.showInvalidOrgAddressError = false;
            } else {
                this.$data.showInvalidOrgAddressError = true;
            }
        },
        expectedLocAddress() {
            const selectedAddress = this.$props.memberRequest.locationAddress;
            if (selectedAddress.latitude) {
                this.$data.showInvalidLocAddressError = false;
            } else {
                this.$data.showInvalidLocAddressError = true;
            }
        },
    },
    validations() {
        const rules = {
            memberRequest: {
                insuranceCompany: {
                    required,
                },
                adjusterEmail: {
                    required,
                    email,
                },
                organizationName: {
                    required,
                    regex: (organizationName: string) => /^[a-zA-Z0-9 ]+$/.test(organizationName),
                },
                organizationAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                },
                locationName: {
                    required,
                    regex: (locationName: string) => /^[a-zA-Z ]+$/.test(locationName),
                },
                locationAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                },
            },
        };
        if (!this.$props.memberRequest.isCaseManager) {
            delete rules.memberRequest.adjusterEmail;
            delete rules.memberRequest.insuranceCompany;
        }
        return rules;
    },
})
export default class Organization extends Vue {

    private orgAddress: any;
    private locAddress: any;
    private accessCodeVerified: boolean = false;
    private locations = [];
    private organizationId = '';
    private invalidAddressError = 'A full address is necessary to proceed';
    private invalidOrganizationAddressError: boolean = true;
    private invalidOfficeAddressError: boolean = true;
    private secondaryOptions: string[] = [];
    private selectedSecondaryOption: string = '';

    public mounted() {
        if (!this.$data.expectedOrgAddress.fullAddress && !this.$props.memberRequest.organizationAddress.latitude) {
            this.$props.memberRequest.organizationAddress.fullAddress = '';
        }
        if (!this.$data.expectedLocAddress.fullAddress && !this.$props.memberRequest.locationAddress.latitude) {
            this.$props.memberRequest.locationAddress.fullAddress = '';
        }
        this.orgAddress = new google.maps.places.Autocomplete((this.$refs.orgAddress), { types: ['geocode'] });
        this.locAddress = new google.maps.places.Autocomplete((this.$refs.locAddress), { types: ['geocode'] });
        this.$props.memberRequest.organizationValid = false;
        if (this.$props.memberRequest.memberType === 'INDIVIDUAL') {
            router.push({ name: MedTransGoConstants.VIEW_PAYMENT_INFORMATION_NAME });
        }
        this.orgAddress.addListener('place_changed', () => {
            const address = MapUtils.parseGoogleAddress(this.orgAddress);
            this.$props.memberRequest.organizationAddress = address;
            this.$data.expectedOrgAddress = address;
            this.invalidOrganizationAddressError = true;
            this.invalidOrganizationAddressError = this.validateAddress(address);
        });
        this.locAddress.addListener('place_changed', () => {
            const address = MapUtils.parseGoogleAddress(this.locAddress);
            this.$props.memberRequest.locationAddress = address;
            this.$data.expectedLocAddress = address;
            this.invalidOfficeAddressError = true;
            this.invalidOfficeAddressError = this.validateAddress(address);
        });
    }

    private saveOrganization() {
        this.$props.memberRequest.organizationValid = true;
        this.$parent.$emit(MedTransGoConstants.EVENT_SAVE_MEMBER_REQUEST);
        this.$router.push({ name: MedTransGoConstants.VIEW_SUBSCRIPTION_PLANS_NAME });
    }

    private gotoPreviousStep() {
        this.$router.push({ name: MedTransGoConstants.VIEW_MEMBER_TYPE_NAME });
    }

    private setOrganization(type: 'NEW_ORG' | 'EXISTING_ORG') {
        this.$props.memberRequest.organizationType = type;
    }

    private async verifyAccessCode() {
        const accessCode = this.$data.accessCode;
        const result = await ObjectFactory.getOrganizationService().verifyAccessCode(this.$store.state.serverUrl,
            accessCode);
        if (result.success) {
            this.accessCodeVerified = true;
            this.locations = result.data.locations;
            this.organizationId = result.data.id;
        } else {
            let errorMessage = '';
            if (result.errorCode) {
                errorMessage = CommonUtils.translateErrorCode(result.errorCode);
            } else if (result.errors) {
                errorMessage = result.errors[0];
            }
            const toastEvent: ToastEvent = {
                message: errorMessage,
                title: 'Validation Failed',
                timeout: 5000,
                varient: 'danger',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private async saveExistingMember() {
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const memberRequest: MemberProfileRequest = {
            memberType: 'ORG_MANAGER',
            organizationType: 'EXISTING_ORG',
            organizationId: this.organizationId,
            locationId: this.$data.locationId,
            userId,
        };
        const apiResponse = await ObjectFactory.getMemberService().
            saveMemberProfile(this.$store.state.serverUrl, memberRequest);
        if (apiResponse.success) {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
        } else {
            CommonUtils.showError(apiResponse);
        }
    }

    private resetAccessCode() {
        this.accessCodeVerified = false;
        this.locations = [];
        this.$data.locationId = '';
        this.organizationId = '';
    }

    private validateAddress(address: Address) {
        return !(!address.city || !address.state || !address.zip);
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }

    private getSubQuestion() {
        const sourceAnswer = this.$props.memberRequest.sourceAnswer;
        switch (sourceAnswer) {
            case 'Search Engine':
                this.$props.memberRequest.sourceDetailsQuestion = 'Which Search Engine?';
                this.secondaryOptions = ['Google', 'Bing', 'Other'];
                break;
            case 'Social Media':
                this.$props.memberRequest.sourceDetailsQuestion = 'Which Social Media?';
                this.secondaryOptions = ['LinkedIn', 'Instagram', 'Facebook', 'YouTube', 'Other'];
                break;
            case 'Referral':
                this.$props.memberRequest.sourceDetailsQuestion = 'From which source?';
                this.secondaryOptions = ['MedTrans Go Team', 'Another healthcare facility', 'Another law firm or funding company', 'Other'];
                break;
            case 'Event':
                this.$props.memberRequest.sourceDetailsQuestion = 'Which type of event?';
                this.secondaryOptions = ['In-Person', 'Virtual'];
                break;
            case 'Advertisement':
                this.$props.memberRequest.sourceDetailsQuestion = 'From which source?';
                this.secondaryOptions = ['Mailer', 'Digital Ad', 'Flyer', 'TV/Radio', 'Billboard', 'Other'];
                break;
            case 'Outreach from MedTrans Go Team':
                this.$props.memberRequest.sourceDetailsQuestion = 'From which source?';
                this.secondaryOptions = ['Phone Call', 'Email'];
                break;
            default:
                this.secondaryOptions = [];
                break;
        }
        this.selectedSecondaryOption = '';
    }

    private handleSecondaryOptionChange() {
        this.$props.memberRequest.sourceDetailsAnswer = this.selectedSecondaryOption;
    }
}
